import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  EditButton,
  TopToolbar,
  CreateButton,
  FunctionField,
  TextInput,
  BulkDeleteButton,
  useNotify,
} from 'react-admin';
import { Card, CardContent, Button } from '@mui/material';
import DeleteWithConfirmButton from "../../components/DeleteWithConfirmButton.tsx";
import { ellipsisCell } from '../../styles/ellipsis.ts';
import UploadButton from '../../components/UploadButton.tsx'; // Add this import
import { ExportButton } from 'react-admin';
import TemplateDownloadButton from '../../components/TemplateDownloadButton.tsx';
import BarChartIcon from '@mui/icons-material/BarChart'; // 图表图标
import { useNavigate } from 'react-router-dom';
const bomFilters = [
  <TextInput sx={{
    '& .MuiInputBase-input': {
      height: 40,      // 输入框高度
      padding: '6px 12px',
      fontSize: 14,
      lineHeight: '40px', // 使文字垂直居中
    },
    minHeight: 36,      // 整体高度
    marginBottom: '16px',
  }} label="Search For Product ID" source="productId" alwaysOn resettable />,

];
const ListActions = () => {
  const notify = useNotify();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';

  const fetchSAPBomData = async () => {
    // 立即通知用户操作已开始
    notify("SAP Boms 数据获取已开始，稍后将通过邮件通知结果", { type: "info" });

    try {
      const token = localStorage.getItem("token"); // 获取 token
      await fetch(`${API_URL}/bom/sap`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`, // 添加 Authorization 头
        },
      });

      // 不需要等待接口完成后再通知用户
    } catch (error) {
      console.error(error);
      notify("获取 SAP Boms 数据失败，请稍后重试", { type: "error" });
    }
  };
  return (
    <TopToolbar sx={{ marginBottom: '16px', }}>
      <Button
        variant="contained"
        color="primary"
        onClick={fetchSAPBomData}
        sx={{ textTransform: "capitalize", marginRight: "8px" }}
      >
        Call SAP API
      </Button>
      <TemplateDownloadButton href="/templates/template.xlsx" />

      <UploadButton resource="bom" onSuccess={() => window.location.reload()} />
      <ExportButton sx={{
        textTransform: 'capitalize', top: '-5px', '& span': {

          marginRight: '2px',
        }
      }} />
      <CreateButton label="New BOM" sx={{
        top: '-5px', '& span': {

          marginRight: '2px',
        }
      }} />
    </TopToolbar>
  )
};

// 自定义操作列，把编辑和删除按钮合并一行显示
const ActionButtons = ({ record }: { record?: any }) => {
  const navigate = useNavigate();

  if (!record) return null;

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      width: '100%',
      textAlign: 'center',
    }}>
      {/* Chart 按钮 */}
      <Button
        // variant="contained"
        color="primary"
        size="small"
        startIcon={<BarChartIcon />}
        sx={{ textTransform: 'capitalize', minWidth: 'auto', marginTop: '2px' }}
        onClick={e => {
          e.stopPropagation(); // 阻止冒泡，防止触发 rowClick
          navigate(`/bom/${record.id}/chart`);
        }}      >
        Chart
      </Button>
      <EditButton record={record} sx={{
        '& .MuiButton-startIcon': {
          marginRight: 0, // 默认是8px，可以缩小为4px或者更小
        }, textTransform: 'capitalize'
      }} />
      <DeleteWithConfirmButton record={record} resource="bom" sx={{
        '& .MuiButton-startIcon': {
          marginRight: 0, // 默认是8px，可以缩小为4px或者更小
        }
      }} />
    </div>
  );
};

const BomList = () => (


  <List
    sx={{ marginTop: '20px', padding: '0 16px' }}
    empty={false}
    filters={bomFilters}
    title="BOM List" actions={<ListActions />} perPage={25}>

    <Datagrid rowClick={false} isRowSelectable={() => true} bulkActionButtons={<BulkDeleteButton label="批量删除" />}
      sx={{
        minWidth: 900,
        '& .RaDatagrid-headerCell': {
          fontWeight: 'bold',
          textAlign: 'center',
        },

        '& .RaDatagrid-rowCell': {
          textAlign: 'center',
        },
      }}

    >
      <TextField source="id" label="BOM id" />
      {/* <TextField source="version" label="Version" /> */}

      {/* <TextField source="stage" label="阶段" /> */}

      {/* <ReferenceField source="productId" reference="materials" label="产品">
                <TextField source="name" />
              </ReferenceField> */}
      <TextField source="product.productId" label="ProductID" />
      <TextField source="product.name" label="ProductName" />
      <TextField className="custom-text-input" source="blendSize" label='blend(kg)' />
      {/* <TextField className="custom-text-input" defaultValue={0} source="lossRate" label='lossRate(%)' /> */}


      <FunctionField
        label="Operations"
        render={record => <ActionButtons record={record} />}
      />
    </Datagrid>

  </List>


);

export default BomList;
